// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "eddbb57cce295bf5b9b1" + ".chunk.js";
};